module.exports = __webpack_public_path__ + "static/Syberia2-da76bfa4ae1a3e4fe0331c2177ff19d4.png";